import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { readUiThemeMode, writeUiThemeMode } from '@/utils/uiPrefs'

type ThemeMode = 'light' | 'dark' | 'system'

interface ThemeState {
  mode: ThemeMode
  resolved: 'light' | 'dark'
  setMode: (mode: ThemeMode) => void
  syncSystem: (prefersDark: boolean) => void
}

function resolveTheme(mode: ThemeMode, prefersDark?: boolean): 'light' | 'dark' {
  if (mode === 'system') {
    const isDark = prefersDark ?? window.matchMedia('(prefers-color-scheme: dark)').matches
    return isDark ? 'dark' : 'light'
  }
  return mode
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: readUiThemeMode(),
      resolved: resolveTheme(readUiThemeMode()),

      setMode: (mode) => {
        writeUiThemeMode(mode)
        set({ mode, resolved: resolveTheme(mode) })
      },

      syncSystem: (prefersDark) => {
        set((state) => {
          if (state.mode !== 'system') return state
          return { resolved: prefersDark ? 'dark' : 'light' }
        })
      },
    }),
    {
      name: 'medcifra-theme',
      partialize: (state) => ({ mode: state.mode }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          const cookieMode = readUiThemeMode()
          state.mode = cookieMode
          state.resolved = resolveTheme(cookieMode)
          writeUiThemeMode(cookieMode)
        }
      },
    }
  )
)
